var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEyeDisable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:eye-disable"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.33338 3.8335L16.6667 17.1668M11.6667 12.3636C11.2244 12.7595 10.6403 13.0002 10.0001 13.0002C8.61934 13.0002 7.50005 11.8809 7.50005 10.5002C7.50005 9.85987 7.74076 9.27579 8.13663 8.8335M16.3399 13.5066C16.816 13.092 17.2419 12.6751 17.6086 12.2892C18.575 11.2725 18.575 9.72781 17.6086 8.71108C15.9788 6.99627 13.1796 4.66683 10.0001 4.66683C9.25724 4.66683 8.53519 4.79396 7.84397 5.0107M5.41672 6.16965C4.20125 6.94553 3.16475 7.89748 2.39147 8.71108C1.42513 9.7278 1.42513 11.2725 2.39147 12.2892C4.02129 14.0041 6.82045 16.3335 10.0001 16.3335C11.5568 16.3335 13.0223 15.7751 14.3041 15.0039",
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEyeDisable);
export default __webpack_public_path__ + "static/media/ic_eye-disable.b6ac8b5baa8c0146ea5e69f9c7678f08.svg";
export { ForwardRef as ReactComponent };